import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment as env } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  constructor(private http:HttpClient){}

  getAllData(params:any = {}):Observable<any[]>{
    let apiUrl = `${env.apiConfig.apirooturi}/items`;
    if(params.startDate){
      apiUrl += '?fromDate='+params.startDate;
    }
    if(params.endDate){
      apiUrl += '&toDate='+params.endDate;
    }
    return this.http.get<any[]>(apiUrl);
  }
}
